import React from "react";
var __jsx = React.createElement;
import BigNumber from 'bignumber.js';
import dayjs from 'dayjs';
import { orderBy } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useModalOpened, useModalSwitch } from "../../../../state/application/hooks";
import { ApplicationModal } from "../../../../state/application/reducer";
import { useUpdaterChainId, BestBuyTradeStatus } from "../../../../hooks";
import { useToken } from "../../../../hooks/useToken";
import { useBestBuyTokens } from "../../../../state/dex/hooks";
import Modal from "../../../Modal";
import { formatUnits } from 'ethers/lib/utils';
import { formatAmount } from "../../help";
import SuccessTradeItem from "./SuccessTradeItem";
import NoTradingOccurredItem from "./NoTradingOccurredItem";
import InsufficientItem from "./InsufficientItem";
import { StyledHeader, StyledHeaderTitle, StyledLabel, StyledHeaderRow, StyledHeaderValue, StyledTradesContainer, StyledYearRow } from "./styled";
export var timeFormat = 'MM-DD';

var groupTradesByYear = trades => {
  var years = trades.map(trade => {
    var tradeDate = new Date(trade.createdAt);
    return tradeDate.getFullYear();
  });
  var uniqueYears = [...new Set(years)];
  var sortedYears = uniqueYears.sort((a, b) => b - a);
  var groupedTrades = sortedYears.map(year => {
    var tradesOfYear = trades.filter(trade => {
      var tradeDate = new Date(trade.createdAt);
      return tradeDate.getFullYear() === year;
    });
    return {
      year,
      trades: tradesOfYear
    };
  });
  return groupedTrades;
};

var OrderDetail = _ref => {
  var order = _ref.order;
  var groupedTrades = groupTradesByYear(order.trades);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var expectChainId = useUpdaterChainId();
  var createdAt = order.createdAt,
      outputTokenAddr = order.dealerToken,
      inputTokenAddr = order.userToken,
      _order$dealerTokenAmo = order.dealerTokenAmount,
      outputTokenAmount = _order$dealerTokenAmo === void 0 ? 0 : _order$dealerTokenAmo,
      _order$userTokenAmoun = order.userTokenAmount,
      inputTokenAmount = _order$userTokenAmoun === void 0 ? 0 : _order$userTokenAmoun;
  var outputTokenOnChain = useToken(outputTokenAddr);
  var inputTokenOnChain = useToken(inputTokenAddr);
  var bestBuyTokens = useBestBuyTokens(expectChainId);
  var inputToken = useMemo(() => {
    return inputTokenOnChain ? inputTokenOnChain : bestBuyTokens[inputTokenAddr];
  }, [inputTokenOnChain, bestBuyTokens]);
  var outputToken = useMemo(() => {
    return outputTokenOnChain ? outputTokenOnChain : bestBuyTokens[outputTokenAddr];
  }, [outputTokenOnChain, bestBuyTokens]);
  var switchOrderDetailModal = useModalSwitch(ApplicationModal.BEST_BUY_ORDER_DETAIL);
  var isOrderDetailModalOpen = useModalOpened(ApplicationModal.BEST_BUY_ORDER_DETAIL);
  var inputAmount = formatUnits(inputTokenAmount, inputToken === null || inputToken === void 0 ? void 0 : inputToken.decimals).toString();
  var outputAmount = formatUnits(outputTokenAmount, outputToken === null || outputToken === void 0 ? void 0 : outputToken.decimals).toString();
  var targetRate = useMemo(() => {
    var result = new BigNumber(inputAmount).div(outputAmount);
    return formatAmount(result);
  }, [inputAmount, outputAmount]);
  return __jsx(Modal, {
    title: t('tokenlon_records'),
    isOpen: isOrderDetailModalOpen,
    onDismiss: () => switchOrderDetailModal(false),
    contentClassName: "bestBuyOrderDetailContent",
    headerClassName: "bestBuyOrderDetailHeader"
  }, __jsx(StyledHeader, null, __jsx(StyledHeaderTitle, null, t('order_detail_title', {
    inputToken: inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol,
    outputToken: outputToken === null || outputToken === void 0 ? void 0 : outputToken.symbol
  })), __jsx(StyledHeaderRow, null, __jsx(StyledLabel, null, t('order_time')), __jsx(StyledHeaderValue, null, dayjs(createdAt).format('YYYY-MM-DD'))), __jsx(StyledHeaderRow, null, __jsx(StyledLabel, null, t('trigger_price')), __jsx(StyledHeaderValue, null, "".concat(targetRate, " ").concat(inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol)))), __jsx(StyledTradesContainer, null, groupedTrades.map(group => {
    return __jsx("div", null, __jsx(StyledYearRow, null, group.year), orderBy(group.trades, ['createdAt'], 'desc').map(trade => {
      var status = trade.status;

      if (status === BestBuyTradeStatus.Success) {
        return __jsx(SuccessTradeItem, {
          key: trade.id,
          trade: trade,
          inputToken: inputToken,
          outputToken: outputToken
        });
      } else if (status === BestBuyTradeStatus.Insufficient || status === BestBuyTradeStatus.AllowanceInsufficient) {
        return __jsx(InsufficientItem, {
          key: trade.id,
          trade: trade
        });
      } else return __jsx(NoTradingOccurredItem, {
        key: trade.id,
        trade: trade
      });
    }));
  })));
};

export default OrderDetail;